<p>{{this.data.text}}</p>
<button class="ff-btn text-info" [mat-dialog-close]="true" cdkFocusInitial title="OK"><i class="fa fa-check"></i></button>
<button class="ff-btn" [mat-dialog-close] title="Cancel"><i class="fa fa-remove"></i></button>
